var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833652 18.4875C0.933659 18.4875 1.042 18.4626 1.15034 18.421L3.60049 17.4308L3.65049 17.4142L17.5013 12.8045V14.5602L4.17552 18.9951L2.50042 19.6691V33.2483C2.50042 33.706 2.87544 34.0804 3.33381 34.0804H6.66734V19.9686C6.66734 19.511 7.04237 19.1365 7.50073 19.1365H14.1678C14.6262 19.1365 15.0012 19.511 15.0012 19.9686V34.0804H18.168C18.2264 34.0887 18.2764 34.1137 18.3347 34.1137H23.335V25.9761C23.335 23.8044 24.9268 21.8657 27.0936 21.6577C29.5771 21.4164 31.6689 23.3634 31.6689 25.793V34.1137H36.6692C37.1275 34.1137 37.5026 33.7393 37.5026 33.2816V11.1404L17.5013 5.70703V11.0489L3.06712 15.8499C3.05046 15.8582 3.03379 15.8582 3.01712 15.8665L2.94211 15.8998L0.516966 16.8816C0.0919403 17.0564 -0.108072 17.539 0.0586051 17.9633C0.191947 18.2878 0.508633 18.4875 0.833652 18.4875ZM27.5019 9.98384C29.3437 9.98384 30.8355 11.4732 30.8355 13.3121C30.8355 15.151 29.3437 16.6403 27.5019 16.6403C25.6602 16.6403 24.1684 15.151 24.1684 13.3121C24.1684 11.4732 25.6602 9.98384 27.5019 9.98384Z",
    fill: "#D2AE5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 20.8008H13.3441V22.4649H8.34375V20.8008Z",
    fill: "#D2AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 30.7891H13.3441V34.084H8.34375V30.7891Z",
    fill: "#D2AE5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 27.4609H13.3441V29.1251H8.34375V27.4609Z",
    fill: "#D2AE5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34375 24.1367H13.3441V25.8008H8.34375V24.1367Z",
    fill: "#D2AE5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1644 0.832064C34.1644 0.374429 33.7893 0 33.331 0H29.9974C29.5391 0 29.1641 0.374429 29.1641 0.832064V3.711L34.1644 5.06727V0.832064Z",
    fill: "#D2AE5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6226 3.47323L38.9574 9.81356C39.0241 9.83852 39.0991 9.84684 39.1741 9.84684C39.5408 9.84684 39.8741 9.60554 39.9741 9.23111C40.0991 8.79012 39.8408 8.33248 39.3908 8.21599L16.056 1.86735C15.6226 1.74254 15.1559 2.00048 15.0393 2.44979C14.9143 2.89078 15.1726 3.34842 15.6226 3.47323Z",
    fill: "#D2AE5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledOne);
export default __webpack_public_path__ + "static/media/al-filled-one.47d1ea605ddd47e3877dab0d68477c5e.svg";
export { ForwardRef as ReactComponent };